// Central content + assets. Placeholder copy — safe to edit.
export const LOGO = "https://customer-assets.emergentagent.com/job_foccus-food-nourish/artifacts/bv0exqjk_CORNERSTONE.png";

export const ORG = {
  name: "Cornerstone FOCCUS Food Pantry",
  short: "Cornerstone FOCCUS",
  tagline: "Sharing the love of Christ by nourishing our neighbors.",
  ein: "85-1207874",
  address: "3416 Blackstone Road, Kenbridge, VA 23944",
  phone: "314-323-2738",
  email: "info@cornerstonefoccus73.org",
  helpEmail: "help@cornerstonefoccus73.org",
  hours: [
    { day: "Tuesday", time: "9:00 AM – 12:00 PM" },
    { day: "Friday", time: "2:30 PM – 4:30 PM" },
  ],
  facebook: "https://www.facebook.com/profile.php?id=61584512682295",
};

export const MISSION =
  "Cornerstone FOCCUS Food Pantry shares the love of Christ by nourishing our neighbors with nutritious food, promoting health and education, and connecting families with resources that strengthen lives. Through compassion, dignity, and community partnerships, we are committed to facing our community's challenges until successful.";

// Founders photo (Pastor Patricia Shelton & the late Bishop James E. Shelton)
export const FOUNDERS_PHOTO =
  "https://customer-assets.emergentagent.com/job_foccus-food-nourish/artifacts/gc69v6z8_506151925_10236391278312301_2645161562208584367_n.jpg";

export const HISTORY = [
  "Cornerstone FOCCUS Food Pantry began as an outreach ministry of The Cornerstone of Deliverance Church, founded by Pastor Patricia Shelton and the late Bishop James E. Shelton. Inspired by their Christian faith and a desire to serve others, they recognized that many families in our community were struggling to meet one of life's most basic needs—access to nutritious food.",
  "What started as a small ministry of compassion has grown into a community-wide resource serving individuals and families throughout Lunenburg County and neighboring communities in Southside Virginia. Guided by the belief that every person should be treated with dignity, respect, and love, the pantry has expanded its services to meet the changing needs of our neighbors.",
  "Today, Cornerstone FOCCUS Food Pantry operates as a choice pantry, allowing families to select the foods that best meet their household's needs and preferences. In addition to providing nutritious food, the pantry offers nutrition education, personal hygiene resources, school supply initiatives, seasonal community outreach events, and connections to other supportive services. Through partnerships with local organizations, churches, businesses, volunteers, and generous donors, our impact extends well beyond our pantry doors.",
  "Each week, we serve more than 300 individuals, each representing a family, while also helping partner organizations distribute food throughout neighboring communities across Southside Virginia.",
  "Although our ministry has grown, our purpose remains unchanged. We continue to serve with the same spirit of faith, compassion, and hope that inspired Pastor Patricia Shelton and Bishop James E. Shelton to begin this work. Every meal provided, every child encouraged, and every family welcomed reflects our commitment to Facing Our Community's Challenges Until Successful.",
];

export const TIMELINE = [
  {
    year: "1973",
    text: "Pastor Patricia Shelton and the late Bishop James E. Shelton found a church in Kenbridge, Virginia. The church serves the congregants and neighboring community by purchasing food for families in need.",
  },
  {
    year: "2011",
    text: "The pantry becomes an organized outreach ministry of The Cornerstone of Deliverance Church.",
  },
  {
    year: "2016",
    text: "The pantry partners with Feed More, Inc., a food bank located in Central Virginia, and expands to serve families throughout Lunenburg County and surrounding Southside Virginia communities; the pantry opens as a choice pantry.",
  },
  {
    year: "2021",
    text: "The Cornerstone FOCCUS Food Pantry restructures as a separate non-profit entity.",
  },
  {
    year: "Today",
    text: "Cornerstone FOCCUS Food Pantry serves more than 300 individuals each week, partners with other organizations to extend its reach across the region, and continues to grow through the support of volunteers, donors, churches, and community partners.",
  },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/6994993/pexels-photo-6994993.jpeg",
  heroEn: "https://static.prod-images.emergentagent.com/jobs/8dbcdade-1b8b-48aa-b037-17f1ffdd6446/images/b3eaa3d8f09d6f358a375756fa69e8ed5423cbe72add812fbf9642a14ba4d68a.png",
  heroEs: "https://static.prod-images.emergentagent.com/jobs/8dbcdade-1b8b-48aa-b037-17f1ffdd6446/images/32ea3c9f7c078f8b8647fbd484a5b15589b7785f967788ba6a77df3f10d61761.png",
  volunteersTent: "/photos/volunteer-truck.jpg",
  sorting: "/photos/foccus-sorting.jpg",
  produce: "/photos/onions.jpg",
  produceBasket: "/photos/dairy.jpg",
  outreachBags: "/photos/volunteer-truck.jpg",
  boxes: "https://images.pexels.com/photos/6591154/pexels-photo-6591154.jpeg?auto=compress&cs=tinysrgb&w=1400",
  community: "/photos/dairy.jpg",
};

export const SHOW_NEWS = false;

export const STATS = [
  { value: "65,000 lbs", label: "Of food distributed each year" },
  { value: "1,200", label: "Pantry visits each month" },
  { value: "650", label: "Children of local families supported" },
  { value: "95¢", label: "Of every $1 goes to programs" },
];

export const NEWS = [
  {
    tag: "Community",
    date: "May 2026",
    title: "Spring Fresh Produce Drive tops 8 tons",
    excerpt:
      "Thanks to partner farms across Lunenburg County, we distributed a record amount of fresh fruits and vegetables this spring.",
    image: IMAGES.produce,
  },
  {
    tag: "Volunteers",
    date: "April 2026",
    title: "Meet our 2026 Volunteer of the Year",
    excerpt:
      "For five years, Ms. Dorothy has greeted every family with a warm smile. Read her story of quiet, faithful service.",
    image: IMAGES.volunteersTent,
  },
  {
    tag: "Programs",
    date: "March 2026",
    title: "New nutrition education classes launch",
    excerpt:
      "Free monthly workshops help families stretch budgets while cooking healthy, delicious meals together.",
    image: IMAGES.produceBasket,
  },
];

// Organizational chart image (uploaded by the client)
export const ORG_CHART =
  "https://customer-assets.emergentagent.com/job_foccus-food-nourish/artifacts/sag0ivxj_Cornerstone%20FOCCUS%20Pantry%20Organization%20Chart.png";

// Clickable team members overlaid on the org chart.
// `hotspot` = center of each person's photo as a % of the chart image (left/top).
// Bios are editable placeholders — replace with real bios anytime.
export const TEAM = [
  {
    name: "Tequisha Stiles",
    role: "Board President & Chief Operations Officer",
    bio: "Tequisha leads Cornerstone FOCCUS with vision and heart, guiding daily operations and steering the board toward our mission of facing our community's challenges until successful.",
    email: "Tequisha.stiles@cornerstonefoccus73.org",
    hotspot: { left: 11.6, top: 64.2, size: 9 },
  },
  {
    name: "James Fowlkes",
    role: "Board Member",
    bio: "James brings dedication and community insight to our board, championing the neighbors we serve across Kenbridge and Lunenburg County.",
    hotspot: { left: 24.7, top: 30.4, size: 8 },
  },
  {
    name: "Todd Wilson",
    role: "Board Member",
    bio: "Todd lends his experience and steady judgment to our board, helping guide the pantry's growth and long-term stability.",
    hotspot: { left: 24.5, top: 41.4, size: 8 },
  },
  {
    name: "Kevin Streat",
    role: "Board Member",
    bio: "Kevin serves on our board with a commitment to stewardship, ensuring every gift is used wisely to nourish our community.",
    hotspot: { left: 24.2, top: 52.2, size: 8 },
  },
  {
    name: "Joyce Freeman",
    role: "Board Member",
    bio: "Joyce brings warmth and compassion to our board, keeping the dignity of every family at the center of our work.",
    hotspot: { left: 24.4, top: 63.0, size: 8 },
  },
  {
    name: "Robert Comly",
    role: "Board Member",
    bio: "Robert supports our mission through thoughtful leadership and a heart for service to neighbors in need.",
    hotspot: { left: 24.3, top: 73.6, size: 8 },
  },
  {
    name: "Fred Thompson",
    role: "Board Member",
    bio: "Fred contributes his time and wisdom to our board, strengthening the partnerships that keep our shelves full.",
    hotspot: { left: 24.5, top: 84.3, size: 8 },
  },
  {
    name: "Kim Bacon",
    role: "Board Member",
    bio: "Kim serves our board with energy and care, helping connect families to the resources that strengthen lives.",
    hotspot: { left: 24.3, top: 94.7, size: 8 },
  },
  {
    name: "Anthony Wilson",
    role: "Logistics Coordinator",
    bio: "Anthony keeps our operation moving — coordinating food deliveries, storage, and distribution so neighbors are served smoothly and on time.",
    hotspot: { left: 52.0, top: 15.9, size: 8 },
  },
  {
    name: "Chiffon Robeson",
    role: "Systems Coordinator",
    bio: "Chiffon manages the systems and processes behind the pantry, ensuring our team runs efficiently and every family is cared for.",
    hotspot: { left: 52.4, top: 31.9, size: 8 },
  },
  {
    name: "Mike Farinacci",
    role: "Intake Specialist",
    bio: "Mike welcomes families at the door, guiding them through intake with patience and respect so they feel seen and supported.",
    hotspot: { left: 52.5, top: 47.9, size: 8 },
  },
  {
    name: "Cynthia Coleman",
    role: "Board Member & Treasurer",
    bio: "Cynthia safeguards our finances as Treasurer, upholding the transparency and accountability our supporters trust.",
    hotspot: { left: 52.5, top: 66.4, size: 8 },
  },
  {
    name: "Naeli Coronel-Leon",
    role: "Community Engagement · Student Volunteer",
    bio: "Naeli connects the pantry with the wider community, bringing fresh energy and a student's perspective to our outreach.",
    hotspot: { left: 52.1, top: 83.3, size: 8 },
  },
  {
    name: "Pantry Volunteers",
    role: "The Heart of Our Mission",
    bio: "Our faithful volunteers are the hands and feet of Cornerstone FOCCUS — sorting food, greeting neighbors, and serving with love every distribution day.",
    hotspot: { left: 87.7, top: 50.4, size: 15 },
  },
];

export const STORIES = [
  {
    quote:
      "When my hours got cut, Cornerstone made sure my kids never went to bed hungry. They treated us like family, not a case number.",
    author: "Tanya M.",
    detail: "Mother of three, Kenbridge",
  },
  {
    quote:
      "The nutrition classes changed how I cook. I feed my family better now, even on a tight budget. I'm so grateful.",
    author: "Robert L.",
    detail: "Retired veteran",
  },
  {
    quote:
      "Volunteering here gave me purpose after retirement. Every Saturday I get to be the hands and feet of Christ.",
    author: "Dorothy P.",
    detail: "Volunteer, 5 years",
  },
];

// Live Givebutter donation form (publish the campaign in Givebutter for it to accept gifts)
export const DONATE_URL = "https://givebutter.com/cornerstone-foccus-food-pantry-vl6d4s";

export const TIERS = [
  { amount: 25, label: "Feeds a family for a week", desc: "Provides fresh groceries and pantry staples." },
  { amount: 50, label: "Stocks a nutrition box", desc: "Fresh produce, protein, and dairy for two weeks." },
  { amount: 100, label: "Sponsors a neighbor for a month", desc: "Full monthly support plus resource connections." },
];
